<template>
  <v-btn v-if="useVuetify" v-bind="$attrs">
    <slot></slot>
  </v-btn>
  <button v-else v-bind="$attrs">
    <slot></slot>
  </button>
</template>

<script setup lang="ts">
import { inject } from 'vue';

defineOptions({
  inheritAttrs: false
})

const useVuetify = inject("useVuetify",false);
</script>